var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import {
  DatePropertyIcon,
  MarkdownPropertyIcon,
  NumericPropertyIcon,
  SelectPropertyIcon,
  TextPropertyIcon,
  RelationshipPropertyIcon,
  IDPropertyIcon,
  GeolocationPropertyIcon,
  ImagePropertyIcon,
  LinkPropertyIcon,
  MediaPropertyIcon,
  PreviewPropertyIcon,
  CustomPropertyIcon } from "../CustomIcons";


const propertyIcons = {
  text: /*#__PURE__*/_jsx(TextPropertyIcon, { className: "w-5 h-5" }),
  date: /*#__PURE__*/_jsx(DatePropertyIcon, { className: "w-5 h-5" }),
  numeric: /*#__PURE__*/_jsx(NumericPropertyIcon, { className: "w-5 h-5" }),
  markdown: /*#__PURE__*/_jsx(MarkdownPropertyIcon, { className: "w-5 h-5" }),
  select: /*#__PURE__*/_jsx(SelectPropertyIcon, { className: "w-5 h-5" }),
  multiselect: /*#__PURE__*/_jsx(SelectPropertyIcon, { className: "w-5 h-5" }),
  relationship: /*#__PURE__*/_jsx(RelationshipPropertyIcon, { className: "w-5 h-5" }),
  generatedid: /*#__PURE__*/_jsx(IDPropertyIcon, { className: "w-5 h-5" }),
  geolocation: /*#__PURE__*/_jsx(GeolocationPropertyIcon, { className: "w-5 h-5" }),
  image: /*#__PURE__*/_jsx(ImagePropertyIcon, { className: "w-5 h-5" }),
  link: /*#__PURE__*/_jsx(LinkPropertyIcon, { className: "w-5 h-5" }),
  media: /*#__PURE__*/_jsx(MediaPropertyIcon, { className: "w-5 h-5" }),
  multidate: /*#__PURE__*/_jsx(DatePropertyIcon, { className: "w-5 h-5" }),
  multidaterange: /*#__PURE__*/_jsx(DatePropertyIcon, { className: "w-5 h-5" }),
  preview: /*#__PURE__*/_jsx(PreviewPropertyIcon, { className: "w-5 h-5" }),
  daterange: /*#__PURE__*/_jsx(DatePropertyIcon, { className: "w-5 h-5" }),
  nested: /*#__PURE__*/_jsx(CustomPropertyIcon, { className: "w-5 h-5" })
};

const propertyIconsSmall = {
  text: /*#__PURE__*/_jsx(TextPropertyIcon, { className: "w-4 h-4" }),
  date: /*#__PURE__*/_jsx(DatePropertyIcon, { className: "w-4 h-4" }),
  numeric: /*#__PURE__*/_jsx(NumericPropertyIcon, { className: "w-4 h-4" }),
  markdown: /*#__PURE__*/_jsx(MarkdownPropertyIcon, { className: "w-4 h-4" }),
  select: /*#__PURE__*/_jsx(SelectPropertyIcon, { className: "w-4 h-4" }),
  multiselect: /*#__PURE__*/_jsx(SelectPropertyIcon, { className: "w-4 h-4" }),
  relationship: /*#__PURE__*/_jsx(RelationshipPropertyIcon, { className: "w-4 h-4" }),
  generatedid: /*#__PURE__*/_jsx(IDPropertyIcon, { className: "w-4 h-4" }),
  geolocation: /*#__PURE__*/_jsx(GeolocationPropertyIcon, { className: "w-4 h-4" }),
  image: /*#__PURE__*/_jsx(ImagePropertyIcon, { className: "w-4 h-4" }),
  link: /*#__PURE__*/_jsx(LinkPropertyIcon, { className: "w-4 h-4" }),
  media: /*#__PURE__*/_jsx(MediaPropertyIcon, { className: "w-4 h-4" }),
  multidate: /*#__PURE__*/_jsx(DatePropertyIcon, { className: "w-4 h-4" }),
  multidaterange: /*#__PURE__*/_jsx(DatePropertyIcon, { className: "w-4 h-4" }),
  preview: /*#__PURE__*/_jsx(PreviewPropertyIcon, { className: "w-4 h-4" }),
  daterange: /*#__PURE__*/_jsx(DatePropertyIcon, { className: "w-4 h-4" }),
  nested: /*#__PURE__*/_jsx(CustomPropertyIcon, { className: "w-4 h-4" })
};

export { propertyIcons, propertyIconsSmall };